<tr appTr *ngIf="section" class="section-header"
    [class.section-header--expanded]="expanded"
    (click)="toggle()">
  <th appTh [attr.colspan]="numOfColumns" class="label">
    <div class="d-flex align-items-center">
      <span class="icon-arrow-down-12 mr-16"></span>
      {{section}}
    </div>
  </th>
</tr>
<ng-container *ngIf="!section || expanded">
  <ng-content></ng-content>
</ng-container>
